<div class="classbook-dialog">
  <dl class="classbook-header">
    <div>
      <dt>Kurs</dt>
      <dd>{{ entry.courseName }}</dd>
    </div>
    <div>
      <dt>Datum</dt>
      <dd>{{ entry.date | date: "EE dd.MM.yyyy" : null : "de-DE" }}</dd>
    </div>
    <div>
      <dt>Dozent</dt>
      <dd>{{ entry.docentName }}</dd>
    </div>
    <div class="classbook-header__wide">
      <dt>Vorgesehenes Thema</dt>
      <dd>{{ entry.topic || "—" }}</dd>
    </div>
  </dl>

  @if (loading) {
    <div class="classbook-loading">
      <p-progressSpinner
        strokeWidth="4"
        styleClass="classbook-spinner"
      ></p-progressSpinner>
    </div>
  } @else if (unavailable) {
    <p class="form-hint form-hint--warn">
      <i class="pi pi-exclamation-triangle"></i> Für diesen Kurs steht kein
      Klassenbuch zur Verfügung.
    </p>
  } @else {
    @if (lernfeldOptions.length === 0) {
      <p class="form-hint form-hint--warn">
        <i class="pi pi-exclamation-triangle"></i> Für diesen Kurs sind keine
        Lernfelder hinterlegt.
      </p>
    }

    @if (existingCount > 0) {
      <p class="form-hint">
        <i class="pi pi-info-circle"></i> Für diesen Tag
        {{ existingCount === 1 ? "existiert bereits ein Eintrag" : "existieren bereits " + existingCount + " Einträge" }}.
        Bereits gespeicherte Einträge können korrigiert, aber nicht entfernt
        werden.
      </p>
    }

    <div class="classbook-entries">
      @for (row of rows; track row.hour) {
        <div class="classbook-entry">
          <div class="classbook-entry__top">
            <div class="classbook-entry__topic">
              <label>Unterrichtsinhalt</label>
              <p-dropdown
                appendTo="body"
                scrollHeight="320px"
                optionLabel="name"
                optionValue="id"
                placeholder="Bitte auswählen"
                [options]="lernfeldOptions"
                [group]="true"
                optionGroupLabel="label"
                optionGroupChildren="items"
                [(ngModel)]="row.lernfeldContentGroupId"
                (ngModelChange)="markDirty(row)"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
              ></p-dropdown>
            </div>

            <!-- Spalte bleibt auch ohne Knopf stehen, sonst wären die Auswahlfelder
                 der Zeilen unterschiedlich breit. -->
            <div class="classbook-entry__action">
              <!-- Gespeicherte Einträge lassen sich nicht löschen, nur überschreiben. -->
              @if (!row.isOriginal) {
                <p-button
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  icon="pi pi-trash"
                  pTooltip="Eintrag entfernen"
                  tooltipPosition="left"
                  (onClick)="removeRow(row)"
                ></p-button>
              }
            </div>
          </div>

          <div class="classbook-entry__remark">
            <label>Bemerkung</label>
            <textarea
              pInputTextarea
              rows="2"
              placeholder="Optional"
              [maxlength]="maxRemarkLength"
              [(ngModel)]="row.remark"
              (ngModelChange)="markDirty(row)"
            ></textarea>
          </div>
        </div>
      }
    </div>

    <p-button
      size="small"
      severity="secondary"
      icon="pi pi-plus"
      label="Eintrag"
      [disabled]="submitting"
      (onClick)="addRow()"
    ></p-button>
  }

  <div class="form-buttons">
    <p-button
      icon="pi pi-times"
      label="Abbrechen"
      severity="secondary"
      [disabled]="submitting"
      (onClick)="close()"
    ></p-button>
    <p-button
      icon="pi pi-save"
      label="Speichern"
      severity="success"
      [disabled]="loading || unavailable || submitting"
      [loading]="submitting"
      (onClick)="save()"
    ></p-button>
  </div>
</div>
